export class Images {
  private static readonly baseUrl = "https://static.4play.com.tr/paycell/kgb/";
  private static readonly baseUrlWallet =
    "https://static.4play.com.tr/wallet-kgb/";
  private static readonly baseUrlKgbApp =
    "https://static.4play.com.tr/kgb-app/";

  public static readonly bg_desktop = `${Images.baseUrl}bg-desktop.png`;
  public static readonly bg_mobile = `${Images.baseUrl}bg-mobile.png`;
  public static readonly campaign_button = `${Images.baseUrl}campaign-button.png`;
  public static readonly chevron_right_orange = `${Images.baseUrl}chevron-right-orange.svg`;
  public static readonly coins_gold = `${Images.baseUrl}coins-gold.png`;
  public static readonly coins_silver = `${Images.baseUrl}coins-silver.png`;
  public static readonly drawer_close = `${Images.baseUrl}drawer-close.png`;
  public static readonly drawer_popup_header_faq = `${Images.baseUrl}drawer-popup-header-faq.png`;
  public static readonly drawer_popup_header_how_to_play = `${Images.baseUrl}drawer-popup-header-how-to-play.png`;
  public static readonly drawer = `${Images.baseUrl}drawer.png`;
  public static readonly drawer_menu_contact = `${Images.baseUrl}drawer-menu-contact.svg`;
  public static readonly drawer_menu_faq = `${Images.baseUrl}drawer-menu-faq.svg`;
  public static readonly drawer_menu_play = `${Images.baseUrl}drawer-menu-play.svg`;
  public static readonly icon_chevron_right_blue = `${Images.baseUrl}icon-chevron-right-blue.svg`;
  public static readonly icon_chevron_right_white = `${Images.baseUrl}icon-chevron-right-white.svg`;
  public static readonly level_5 = `${Images.baseUrl}level-5.svg`;
  public static readonly logo = `${Images.baseUrlWallet}logo.png`;
  public static readonly logo_with_note = `${Images.baseUrlWallet}logo-with-note.png`;
  public static readonly logo_kgb_app = `${Images.baseUrlKgbApp}jeton/offer_kfi.png`;
  public static readonly offer_icon_final = `${Images.baseUrl}offer-icon-final.svg`;
  public static readonly offer_icon_gift = `${Images.baseUrl}offer-icon-gift.svg`;
  public static readonly offer_icon_star_giveup = `${Images.baseUrl}offer-icon-star-giveup.svg`;
  public static readonly offer_icon_star = `${Images.baseUrl}offer-icon-star.svg`;
  public static readonly offer_icon_ticket = `${Images.baseUrl}offer-icon-ticket.svg`;
  public static readonly option_correct = `${Images.baseUrl}option-correct.svg`;
  public static readonly option_fail = `${Images.baseUrl}option-fail.svg`;
  public static readonly point = `${Images.baseUrl}point.svg`;
  public static readonly popup_header_bg_confetti = `${Images.baseUrl}popup-header-bg-confetti.png`;
  public static readonly popup_header_icon_check = `${Images.baseUrl}popup-header-icon-check.svg`;
  public static readonly popup_header_icon_congrats = `${Images.baseUrl}popup-header-icon-congrats.svg`;
  public static readonly popup_header_icon_decision = `${Images.baseUrl}popup-header-icon-decision.svg`;
  public static readonly popup_header_icon_gift = `${Images.baseUrl}popup-header-icon-gift.svg`;
  public static readonly popup_header_icon_giveup = `${Images.baseUrl}popup-header-icon-giveup.svg`;
  public static readonly popup_header_icon_opportunity = `${Images.baseUrl}popup-header-icon-opportunity.svg`;
  public static readonly popup_header_icon_time_expired = `${Images.baseUrl}popup-header-icon-time-expired.svg`;
  public static readonly popup_header_icon_wrong = `${Images.baseUrl}popup-header-icon-wrong.svg`;
  public static readonly popup_icon_are_you_sure = `${Images.baseUrl}popup-icon-are-you-sure.svg`;
  public static readonly popup_icon_checkmark = `${Images.baseUrl}popup-icon-checkmark.svg`;
  public static readonly popup_icon_fund = `${Images.baseUrl}popup-icon-fund.svg`;
  public static readonly popup_icon_warning = `${Images.baseUrl}popup-icon-warning.svg`;
  public static readonly star_gold = `${Images.baseUrl}star-gold.svg`;
  public static readonly star_silver = `${Images.baseUrl}star-silver.svg`;
  public static readonly user_rank = `${Images.baseUrl}user-rank.svg`;
  public static readonly x = `${Images.baseUrl}x.svg`;
  public static readonly scoreboard_banner = `${Images.baseUrlWallet}kgb-wallet-banner.jpeg`;
  public static readonly how_to_play = `${Images.baseUrl}how-to-play.svg`;
  public static readonly leaderboard_1 = `${Images.baseUrlWallet}leaderboard-1.svg`;
  public static readonly leaderboard_2 = `${Images.baseUrlWallet}leaderboard-2.svg`;
  public static readonly leaderboard_3 = `${Images.baseUrlWallet}leaderboard-3.svg`;
}
